import React from "react";

// import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import playstore from "../../../src/assets/img/badge_googleplay.svg";
import appstore from "../../../src/assets/img/badge_appstore.svg";
import myploscreen from "../../../src/assets/img/footerBatch.png";
import CategoryList from "views/Component/CategoryList";
import AppPlayStore from "views/Component/AppPlayStore";
const PartySuppliesCategories = () => {
  return (
    <>
      <div className="margindiv-header">
        <div className="partysuplies-cateris">
          <Container>
            <div className="myplo-title-h2 text-center d-block">
              <h2 className="mb-3">
                <span className="shape"></span>Party Supplies by Occasion
              </h2>
              <p>Find Party Supplies, Costumes & Leftovers for Less—Give Extras a Second Life!</p>
            </div>
            <CategoryList role={"partySupply"} type={"all"}/>
          </Container>
        </div>
        <AppPlayStore />

      </div>
    </>
  );
};

export default PartySuppliesCategories;
